import React, { createContext, useState } from 'react';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';

type GroupByOpt = string | undefined;
export const PivotTableContext = createContext<{
  groupByOpts: GroupByOpt[];
  setGroupByOpts: React.Dispatch<React.SetStateAction<GroupByOpt[]>>;
}>(undefined!);
export type PivotTableContextProps = {
  groupByOpts: GroupByOpt[];
  onGroupByOptsChange?: (groupByOpts: GroupByOpt[]) => void;
};
export const PivotTableContextProvider: ReactFCC<PivotTableContextProps> = ({
  groupByOpts: initGroupByOpts,
  onGroupByOptsChange,
  children,
}) => {
  const [groupByOpts, setGroupByOptsState] =
    useState<GroupByOpt[]>(initGroupByOpts);

  const setGroupByOpts: typeof setGroupByOptsState = (args) => {
    const value = typeof args === 'function' ? args(groupByOpts) : args;
    onGroupByOptsChange?.(value);
    setGroupByOptsState(args);
  };

  return (
    <PivotTableContext.Provider
      value={{
        groupByOpts,
        setGroupByOpts,
      }}
    >
      {children}
    </PivotTableContext.Provider>
  );
};
